import axios from 'axios'
import storage from './storage.js'
import router from '../router'

// console.log(document.origin)
axios.defaults.timeout = 180000;// request timeout
// axios.defaults.baseURL = window.g.baseUrl; // url = base url + request url
axios.defaults.baseURL = document.location.origin + "/pay-mall-srv"; // url = base url + request url
axios.defaults.withCredentials = true;// send cookies when cross-domain requests

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.method.toLowerCase() === 'post') {
      config.data = JSON.stringify(config.data);
      config.headers = {
        'Content-Type': 'application/json'
      }
    } else if (config.method === 'get') {
      config.params = {
        t: new Date().getTime(),
        ...config.params
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log(res);
    // if the custom code is not 0, it is judged as an error.
    if (res.code === 100) {
      // 跳转登录
      storage.removeUserName();
      var currentPath = router.currentRoute.fullPath;
      if (currentPath) {
        if (currentPath.indexOf("/login") >= 0) {
          router.push(currentPath);
        } else {
          router.push('/login?redirect=' + currentPath);
        }
      } else {
        router.push('/login');
      }
      return res;
    } else if (res.code === 106) {
      router.push('/');
      return res;
    } else if (res.code === 9999) {
      router.push('/');
      return res;
    } else if (res.code === 404) {
      router.push('/404');
      return res;
    } else {
      return res
    }
  },
  error => {
    console.log('error' + error) // for debug
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: data
    })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
  })
}


// WEBPACK FOOTER //
// ./src/utils/http.js